import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { Avatar } from 'primeng/avatar';
import { EditorModule } from 'primeng/editor';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { RippleModule } from 'primeng/ripple';
import { DialogModule } from 'primeng/dialog';

import { DialogoPadraoDirective } from '@/shared/components/layout/dialogo-padrao/dialogo-padrao.directive';
@Component({
    selector: 'app-compose-email-orientacoes',
    standalone: true,
    imports: [DialogoPadraoDirective, FormsModule, ButtonModule, Avatar, EditorModule, IconFieldModule, InputIconModule, RippleModule, DialogModule],
    templateUrl: './compose-email-orientacoes.html',
    styleUrls: ['./compose-email-orientacoes.scss']
})
export class ComposeEmailOrientacoesComponent {
    // Controle de exibição do diálogo
    @Input() visible = false;
    @Output() visibleChange = new EventEmitter<boolean>();

    // Remetente exibido no cabeçalho (imagem e nome vindos do dashboard)
    @Input() remetente: { nome: string; avatar: string } = {
        nome: 'Remetente',
        avatar: 'images/placeholder/avatar.png'
    };

    @Input() messageTitle: string = '';

    // Dados da mensagem original para exibição (mockado conforme imagem)
    originalMessage = {
        subject: 'Apply These 7 Secret Techniques To Improve Event Apply These',
        content: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.`,
        date: '19 de Março de 2025',
        to: 'crm@gmail.com'
    };

    // Interface e estado local do envio de e-mail (standalone)
    emailData: {
        to: string;
        subject: string;
        content: string;
        attachments?: File[];
    } = {
        to: 'crm@gmail.com', // Pre-filled for mock
        subject: 'Re: Apply These 7 Secret Techniques To Improve Event Apply These', // Pre-filled
        content: '',
        attachments: []
    };

    onFilesSelected(event: Event): void {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files.length) {
            const newFiles = Array.from(input.files);
            const current = this.emailData.attachments ?? [];
            this.emailData.attachments = [...current, ...newFiles];
            // reset do input para permitir selecionar o mesmo arquivo novamente
            input.value = '';
        }
    }

    removeAttachment(index: number): void {
        if (!this.emailData.attachments) return;
        this.emailData.attachments = this.emailData.attachments.filter((_, i) => i !== index);
    }

    onSendMessage(): void {
        if (this.isFormValid()) {
            // eslint-disable-next-line no-console
            console.log('E-mail (orientações) enviado:', { ...this.emailData });
            // manter abertura a critério do chamador; aqui apenas fechamos se desejar
        }
    }

    onCancel(): void {
        // Reset do formulário
        this.emailData = { to: '', subject: '', content: '', attachments: [] };
        // Fechar o diálogo
        if (this.visible) {
            this.visible = false;
            this.visibleChange.emit(false);
        }
    }

    isFormValid(): boolean {
        return true;
    }

    visualizarAnexo(): void {
        console.log('Visualizar anexo clicado');
    }
}
